import { Card, Select, Skeleton } from "antd";
import {
  LineChart,
  Line,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  Label,
  YAxis,
  Legend,
} from "recharts";
import moment from "moment";
import { useState } from "react";
import { LineChartOutlined } from "@ant-design/icons";

const { Option } = Select;

const styles = {
  height: "30px",
};

const ChartCard = ({
  label = "--",
  info = "--",
  chartData,
  loading,
  selectedYear,
  setSelectedYear,
}) => {
  const graphData = [
    { date: "2022-01-01", payout: 100, revenue: 200 },
    { date: "2022-02-01", payout: 150, revenue: 250 },
    { date: "2023-01-01", payout: 120, revenue: 220 },
    { date: "2023-02-01", payout: 180, revenue: 260 },
    { date: "2024-01-01", payout: 200, revenue: 300 },
    { date: "2024-02-01", payout: 170, revenue: 280 },
  ];

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  const filteredData = graphData.filter(
    (data) => moment(data.date).year() === selectedYear
  );

  // const years = [...new Set(graphData.map((data) => moment(data.date).year()))];
  const currentYear = moment().year();
  const years = Array.from(
    { length: currentYear - 2023 + 1 },
    (_, i) => 2023 + i
  );

  // Custom Tick component for YAxis
  const CustomizedTick = ({ x, y, payload }) => {
    return (
      <text
        x={x}
        y={y}
        dy={2}
        dx={-25}
        textAnchor="middle"
        fill="#666"
        fontSize={12}
      >
        ${payload.value}
      </text>
    );
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return monthNames[monthNumber - 1];
  };

  const CustomizedTickX = ({ x, y, payload }) => {
    return (
      <text x={x} y={y} dy={19} textAnchor="middle" fill="#666" fontSize={12}>
        {getMonthName(payload.value.split("-")[1])}
      </text>
    );
  };

  return (
    <>
      <Card className="rounded-2xl bg-white xl:relative">
        <div className="border-solid border-inputFieldGrey rounded-sm p-2">
          {loading && (
            <div className="flex items-center justify-center min-h-[300px]">
              <div>
                <Skeleton.Node active={true}>
                  <LineChartOutlined
                    style={{ fontSize: 100, color: "#cfcfcf" }}
                  />
                </Skeleton.Node>
              </div>
            </div>
          )}
          {!loading && (
            <>
              <div className="flex items-center justify-between">
                <div>
                  <span className="mock-block text-lg"> {info}</span>
                </div>

                <div>
                  <Select
                    defaultValue={selectedYear}
                    style={{ width: 120 }}
                    onChange={handleYearChange}
                  >
                    {years.map((year) => (
                      <Option key={year} value={year}>
                        {year}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              <ResponsiveContainer className="mt-2" width="100%" height={300}>
                <LineChart
                  width={500}
                  height={350}
                  data={chartData}
                  // margin={{
                  //   top: 5,
                  //   right: 30,
                  //   left: 20,
                  //   bottom: 5,
                  // }}
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis
                    dataKey="date"
                    // domain={[0, "auto"]}
                    tick={<CustomizedTickX />}
                  />
                  <YAxis domain={[0, "auto"]} tick={<CustomizedTick />} />

                  <Tooltip formatter={(value) => value?.toFixed(2)} />
                  <Line
                    type="monotone"
                    dataKey="payout"
                    stroke="#F6A903"
                    strokeWidth={2}
                    activeDot={{ r: 8 }}
                  />
                  <Line
                    type="monotone"
                    strokeWidth={2}
                    dataKey="revenue"
                    stroke="#8884d8"
                  />
                </LineChart>
              </ResponsiveContainer>
            </>
          )}
        </div>
      </Card>
    </>
  );
};

export default ChartCard;
